<div class="main">
  <spb-header></spb-header>
  <div [style.flex]="1"></div>
  <div class="content">
    <router-outlet></router-outlet>
    @if (configService.isUser$()) {
      <button (click)="configService.logout()" mat-raised-button>Logga ut
      </button>
    }
  </div>

  <div [style.flex]="4"></div>
  <spb-footer
    (logoutUser)="configService.logout()"
    [license]="true"
    [token]="(configService.accessToken$ | async)"
    [version]="version"
    copyrightYears="2025"
  ></spb-footer>
</div>
